export const LOCATIONS_FEATURES = {
  moduleKey: 'locations',
  features: ['locations.view', 'locations.manage'] as const,
  featureMeta: {
    'locations.view': {
      name: 'Locations',
      translations: { name: { de: 'Standorte', en: 'Locations', fr: 'Emplacements', it: 'Sedi' } },
    },
    'locations.manage': {
      name: 'Manage locations',
      translations: { name: { de: 'Standorte verwalten', en: 'Manage locations', fr: 'Gérer les emplacements', it: 'Gestire le sedi' } },
    },
  },
} as const;
